import React from 'react';
import { TableRow } from 'semantic-ui-react';

import { WorksheetPageIndex } from 'services/worksheet/types';
import { SprayProductId } from 'services/sprayEvents/types';
import ProductNameTableCell from './components/ProductNameTableCell';
import ProductOrderTableCell from './components/ProductOrderTableCell';
import ProductReEntryPeriodDaysTableCell from './components/ProductReEntryPeriodDaysTableCell';
import ProductWitholdingPeriodDaysTableCell from './components/ProductWitholdingPeriodDaysTableCell';
import ProductRatePerHundredLitreTableCell from './components/ProductRatePerHundredLitreTableCell';
import ProductRatePerAreaTableCell from './components/ProductRatePerAreaTableCell';
import ProductRatePerTankTableCell from './components/ProductRatePerTankTableCell';
import ProductWaterRateTableCell from './components/ProductWaterRateTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: SprayProductId;
}

type Props = OwnProps;

export default class PrintSprayWorksheetProductsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productId, pageIndex } = this.props;

        return (
            <TableRow>
                <ProductNameTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductRatePerHundredLitreTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductRatePerAreaTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductRatePerTankTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductWaterRateTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductOrderTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductReEntryPeriodDaysTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
                <ProductWitholdingPeriodDaysTableCell
                    productId={productId}
                    pageIndex={pageIndex}
                />
            </TableRow>
        );
    }
}
